export default __webpack_public_path__ + "static/media/warning.60687cee.mp3";